import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { type CustomerFoodFeedback, StatusCode } from '@hungryroot/rest';
import {
  postApiV2CustomersCustomerIdFoodFeedback,
  type Params,
} from '@hungryroot/rest/api/v2/customers/[id]/food_feedback/post';

type UsePostCustomerFoodFeedbackProps<Context> = Omit<
  UseMutationOptions<CustomerFoodFeedback, Error, Params, Context>,
  'mutationFn'
>;

export function usePostCustomerFoodFeedback<Context>(
  props?: UsePostCustomerFoodFeedbackProps<Context>
) {
  return useMutation({
    mutationFn: async (params: Params) => {
      const { customer_id, requestBody } = params;

      const res = await postApiV2CustomersCustomerIdFoodFeedback({
        customer_id,
        requestBody,
      });

      if (res.status !== StatusCode.SuccessCreated) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }

      return res.data;
    },
    ...props,
  });
}
